import Cookies from 'js-cookie';
import {useAuth} from "./useAuth";
import {ref} from "vue";
import {API_BASE_URL} from "../config";
export const errorMessage = ref('');
export const isDialogVisible = ref(false);
const apiRequest = async (url: string, options: RequestInit = {}) => {
    try {
        let {getToken}=useAuth();
        // Ensure access token is available
        let accessToken = await getToken();
        if (!accessToken) {
            throw new Error('No access token available');
        }

        // Add Authorization header
        options.headers = {
            ...options.headers,
            Authorization: `Bearer ${accessToken}`,
        };

        // Make the API request
        let response = await fetch(url, options);

        // If the token is expired, refresh it
        if (response.status === 401) {
            const refreshToken = Cookies.get('refreshToken');
            if (!refreshToken) {
                throw new Error('No refresh token available');
            }

            // Refresh the token
            const refreshResponse = await fetch(`${API_BASE_URL}/api/auth/refreshtoken`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ refreshToken }),
            });

            if (!refreshResponse.ok) {
                throw new Error('Failed to refresh token');
            }

            const refreshData = await refreshResponse.json();
            Cookies.set('accessToken', refreshData.accessToken);

            // Retry the original request with the new token
            options.headers.Authorization = `Bearer ${refreshData.accessToken}`;
            response = await fetch(url, options);
        }
        // Handle non-OK responses
        if (!response.ok) {
            const errorData = await response.json();
            errorMessage.value = errorData.message || 'Login failed';
            isDialogVisible.value = true;
            throw new Error(errorMessage.value);
        }

        return await response.json();
    } catch (error: any) {
        console.error('API Request Error:', error.message);
        throw error;
    }
};

export default apiRequest;